export const LOAD_SUPPLIER_ORDER_DETAIL = 'LOAD_SUPPLIER_ORDER_DETAIL'
export const LOAD_SUPPLIER_ORDER_DETAIL_SUCCESS = 'LOAD_SUPPLIER_ORDER_DETAIL_SUCCESS'
export const LOAD_SUPPLIER_ORDER_DETAIL_FAILED = 'LOAD_SUPPLIER_ORDER_DETAIL_FAILED'

export const CLEAR_SUPPLIER_ORDER_DETAIL = 'CLEAR_SUPPLIER_ORDER_DETAIL'
